module.exports = __webpack_public_path__ + "static/img/pay-success.5801e2cb.png";